module.exports = __webpack_public_path__ + "static/cleric-harnesses-divine-power-bd7ff4e295ab0c17b19a2e44c3fc235d.png";